export default __webpack_public_path__ + "static/2-4197e2e8e1c810fbcd635df1e3fb52b2.jpeg";